import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useTask, Task } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Task>
      useData={useTask}
      config={{
        ...moduleConfig,
        getDetailSections: (item: Task, formatDate: (dateString?: string) => string) => 
          getDetailSections(item, formatDate, moduleConfig.utils.formatDateTime),
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

